/*
 * Copyright (c) Ekathva Innovations Private Limited- All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * Proprietary and confidential
 *
 * Author: Nikitha S Bhatt (nikitha@ekathvainnovations.com), Akshay K Kulkarni (akshay.kulkarni@ekathvainnovations.com)
 *
 * Date:08-06-2021
 *
 * Filename: ItTechnologies
 * Page name:
 * Page Description:
 */

import React from 'react'
import { Row, Col, Image } from 'react-bootstrap'
import Carousel from "react-multi-carousel";

import Html from "assets/images/TechLogo/PNG/Html.png"
import Css from "assets/images/TechLogo/PNG/Css.png"
import Bootstrap from "assets/images/TechLogo/PNG/Bootstrap.png"
import Angular from "assets/images/TechLogo/PNG/Angular.png"
import ReactJs from "assets/images/TechLogo/PNG/React.png"
import Node from "assets/images/TechLogo/PNG/Node.png"

import Mysql from "assets/images/TechLogo/PNG/Mysql.png"
import Mongo from "assets/images/TechLogo/PNG/Mongo.png"
import Firebase from "assets/images/TechLogo/PNG/Firebase.png"
import Aws from "assets/images/TechLogo/PNG/Aws.png"
import Php from "assets/images/TechLogo/PNG/Php.png"
import Spring from "assets/images/TechLogo/PNG/Spring.png"

import Java from "assets/images/TechLogo/PNG/Java.png"
import Android from "assets/images/TechLogo/PNG/Android.png"
import Ionic from "assets/images/TechLogo/PNG/Ionic.png"
import Flutter from "assets/images/TechLogo/PNG/Flutter.png"
import Python from "assets/images/TechLogo/PNG/Python.png"
import Xcode from "assets/images/TechLogo/PNG/Xcode.png"

import Figma from "assets/images/TechLogo/PNG/Figma.png"
import Corel from "assets/images/TechLogo/PNG/Corel.png"
import Photoshop from "assets/images/TechLogo/PNG/Photoshop.png"
import Illustrator from "assets/images/TechLogo/PNG/Illustrator.png"
import Premiere from "assets/images/TechLogo/PNG/Premiere.png"

const responsive = {
  superLargeDesktop: {

    breakpoint: { max: 4000, min: 3000 },
    items: 1
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
};

function ItTechnologies() {


  return (
  <div>
    <div className='embedded_listdisplay1'>
    <Carousel
    className='carouselBorder'
    autoPlay={true}
    responsive={responsive}
    infinite={true}
    autoPlaySpeed={2500}>

    <Row>

    <Col className='center'>
    <Image img src={Html} alt="HTML 5" className='embedded_techimg' />
    </Col>

    <Col className='center'>
    <Image img src={Css} alt="CSS3" className='embedded_techimg' />
    </Col>

    <Col className='center'>
    <Image img src={Bootstrap} alt="Bootstrap" className='embedded_techimg' />
    </Col>

    <Col className='center'>
    <Image img src={Angular} alt="Angular" className='embedded_techimg' />
    </Col>

    </Row>

    <Row>

    <Col className='center'>
    <Image img src={ReactJs} alt="ReactJs" className='embedded_techimg' />
    </Col>

    <Col className='center'>
    <Image img src={Node} alt="NodeJS" className='embedded_techimg' />
    </Col>

    <Col className='center'>
    <Image img src={Mysql} alt="Mysql" className='embedded_techimg' />
    </Col>

    <Col className='center'>
    <Image img src={Mongo} alt="MongoDB" className='embedded_techimg' />
    </Col>

    </Row>

    <Row>
    <Col className='center'>
    <Image img src={Firebase} alt="Firebase" className='embedded_techimg' />
    </Col>

    <Col className='center'>
    <Image img src={Aws} alt="AWS" className='embedded_techimg' />
    </Col>

    <Col className='center'>
    <Image img src={Php} alt="PHP" className='embedded_techimg' />
    </Col>

    <Col className='center'>
    <Image img src={Spring} alt="Spring Boot" className='embedded_techimg' />
    </Col>
    </Row>

    <Row>

    <Col className='center'>
    <Image img src={Java} alt="Java" className='embedded_techimg' />
    </Col>

    <Col className='center'>
    <Image img src={Android} alt="Android Studio" className='embedded_techimg' />
    </Col>

    <Col className='center'>
    <Image img src={Ionic} alt="Ionic Framework" className='embedded_techimg' />
    </Col>

    <Col className='center'>
    <Image img src={Flutter} alt="Flutter" className='embedded_techimg' />
    </Col>

    </Row>

    <Row>

    <Col className='center'>
    <Image img src={Python} alt="Python" className='embedded_techimg' />
    </Col>

    <Col className='center'>
    <Image img src={Xcode} alt="Xcode" className='embedded_techimg' />
    </Col>

    <Col className='center'>
    <Image img src={Figma} alt="Figma" className='embedded_techimg' />
    </Col>

    <Col className='center'>
    <Image img src={Corel} alt="Corel Draw" className='embedded_techimg' />
    </Col>

    </Row>

    <Row>
    <Col className='center'>
    <Image img src={Photoshop} alt="Adobe Photoshop" className='embedded_techimg' />
    </Col>

    <Col className='center'>
    <Image img src={Illustrator} alt="Adobe Illustrator" className='embedded_techimg' />
    </Col>

    <Col className='center'>
    <Image img src={Premiere} alt="Adobe Premiere Pro" className='embedded_techimg' />
    </Col>
    </Row>


    </Carousel>
    </div>

    </div>
  )
}

export default ItTechnologies
